import { z } from "zod";
import "./error-map";

export const createSaleItemSchema = z.object({
	productId: z.number().int().positive(),
	quantity: z.number().positive(),
	unitPrice: z.number().min(0),
	taxRate: z.number().min(0).max(100).optional().default(0),
	discountRate: z.number().min(0).max(100).optional().default(0),
});

export const createSaleSchema = z.object({
	customerId: z.number().int().positive().optional(),
	branchId: z.number().int().positive().optional(),
	posId: z.number().int().positive().optional(),
	tableNumber: z.string().max(32).optional(),
	notes: z.string().optional(),
	items: z.array(createSaleItemSchema).min(1, "validation.itemsRequired"),
	subtotal: z.number().min(0).optional(),
	totalAmount: z.number().min(0).optional(),
	orderSource: z.enum(["admin", "cashier", "online_menu", "third_party", "api"]).optional(),
});

export type CreateSaleItemInput = z.infer<typeof createSaleItemSchema>;
export type CreateSaleInput = z.infer<typeof createSaleSchema>;
